import { render, staticRenderFns } from "./ModalAlterarSenha.vue?vue&type=template&id=97dbbe92&"
import script from "./ModalAlterarSenha.vue?vue&type=script&lang=js&"
export * from "./ModalAlterarSenha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports